import React, { Component } from "react";
import { connect } from "react-redux";
import { BttnYes } from "./BttnYes";
import { setAnswer } from "../../../actions/answer";
import { withRouter } from "react-router-dom";

import "./styles.css";

class QuestionnaireYesNo extends Component {
  componentDidMount() {
    this.props.setAnswer({
      answer: false
    })
  }
  render() {
    const { data, setAnswer } = this.props;

    return (
      <div className="content">

        {/* <h4>Въпрос {data.questionNumber}</h4>*/}
        <div class="title">{data.text}</div>
        <div className="learn"><p>{data.details}</p></div>
        <form className="form">
          <BttnYes text="Да" onClick={isYes => setAnswer({ answer: !isYes })} />
        </form>

      </div>
    );
  }
}

const mstp = (state, ownProps) => ({
  answer: state.answer.collection[ownProps.match.params.id - 1]
});

const mdtp = (dispatch, ownProps) => ({
  setAnswer: payload =>
    dispatch(
      setAnswer({
        id: +ownProps.match.params.id,
        ...payload
      })
    )
});

export default withRouter(
  connect(
    mstp,
    mdtp
  )(QuestionnaireYesNo)
);



// WEBPACK FOOTER //
// ./src/screens/Questionnaire/QuestionnaireYesNo/QuestionnaireYesNo.js